import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { COLORS } from '@fupa/fupa-uikit';
const TeamComparisonChart = _ref => {
  var _homeTeam$name, _awayTeam$name;
  let {
    homeTeam,
    awayTeam,
    statistics
  } = _ref;
  const xAxisData = homeTeam && awayTeam ? ["Siege ".concat(homeTeam === null || homeTeam === void 0 || (_homeTeam$name = homeTeam.name) === null || _homeTeam$name === void 0 ? void 0 : _homeTeam$name.middle), 'Remis', "Siege ".concat(awayTeam === null || awayTeam === void 0 || (_awayTeam$name = awayTeam.name) === null || _awayTeam$name === void 0 ? void 0 : _awayTeam$name.middle)] : ['Siege Heim', 'Remis', 'Siege Gast'];
  const seriesData = Object.keys(statistics).length ? [statistics.homeTeamWins, statistics.draws, statistics.awayTeamWins] : [0, 0, 0];
  return /*#__PURE__*/React.createElement(BarChart, {
    height: 250,
    sx: {
      'rect:first-of-type': {
        fill: COLORS.lightGreen
      },
      'rect:nth-of-type(2)': {
        fill: COLORS.lightGrey
      },
      'rect:nth-of-type(3)': {
        fill: COLORS.lightRed
      }
    },
    series: [{
      data: seriesData,
      color: COLORS.lightGrey
    }],
    xAxis: [{
      id: 'barCategories',
      data: xAxisData,
      scaleType: 'band'
    }],
    "data-sentry-element": "BarChart",
    "data-sentry-component": "TeamComparisonChart",
    "data-sentry-source-file": "TeamComparisonChart.tsx"
  });
};
export default TeamComparisonChart;